var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirst(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 50,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #305549;\n      }\n\n      .cls-3 {\n        isolation: isolate;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    className: "cls-1",
    cx: 5,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.63,3.81v-.96h1.68V7.27h-1.08V3.81h-.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.84,3.35c.11-.06,.22-.09,.35-.09v.64h-.17c-.15,0-.26,.03-.34,.1-.08,.06-.11,.18-.11,.34v.92h-.6v-1.97h.6v.33c.07-.11,.16-.19,.27-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.33,4.41h-1.37c0,.12,.05,.22,.12,.28,.07,.06,.15,.1,.26,.1,.15,0,.26-.06,.31-.19h.64c-.03,.13-.09,.25-.18,.35-.09,.1-.19,.19-.32,.24s-.27,.09-.43,.09c-.19,0-.37-.04-.52-.12s-.27-.2-.35-.35c-.08-.15-.13-.33-.13-.54s.04-.38,.13-.54c.08-.15,.2-.27,.35-.35,.15-.08,.32-.12,.52-.12s.36,.04,.51,.12,.26,.19,.35,.34c.08,.15,.12,.32,.12,.52,0,.06,0,.12-.01,.18Zm-.61-.34c0-.1-.04-.19-.11-.25-.07-.06-.16-.09-.27-.09s-.19,.03-.26,.09-.11,.14-.13,.25h.76Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirst);
export default __webpack_public_path__ + "static/media/first.333fd6701ada1a00769fd44984614ffb.svg";
export { ForwardRef as ReactComponent };